import React from 'react';

interface Props {
    active?: boolean;
    className?: string;
    color?: string;
}

export default class Star extends React.PureComponent<Props> {
    public render() {
        const { className, active, color: propsColor } = this.props;
        const color = propsColor || (active ? '#6839CF' : '#DEE1E8');

        return (
            <svg
                className={className}
                width="100%"
                height="100%"
                viewBox="0 0 36 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18 0L23.7344 10.1072L35.119 12.4377L27.2785 21.0148L28.5801 32.5623L18 27.756L7.41987 32.5623L8.72149 21.0148L0.880983 12.4377L12.2656 10.1072L18 0Z"
                    fill={color}
                />
            </svg>
        );
    }
}
